import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { InfoIcon } from "../../assets/icons";
import { useAppSelector } from "../../hooks/hooks";
import useClickOutside from "../../hooks/useClickOutside";
import { WalletDropdownProps } from "./types";
import { convertCurrency, formatCurrency } from "../../utils/utils";

export const WalletDropdown: React.FC<WalletDropdownProps> = ({
  setIsOpen,
  walletBtnRef,
}) => {
  const walletRef = useClickOutside(
    () => {
      setIsOpen(false);
    },
    true,
    walletBtnRef
  );
  const { t } = useTranslation();
  const translate = t as unknown as (key: string) => string;
  const { user } = useAppSelector((state) => state.auth);
  const { data: appData } = useAppSelector((state) => state.appData);
  const { selectedCurrency } = useAppSelector((state) => state.locale);
  const navigate = useNavigate();
  return (
    <div
      ref={walletRef}
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => {
        e.stopPropagation();
      }}
      className="bg-white dark:bg-black rounded-lg shadow-md w-[268px] z-50"
    >
      <div className="p-4">
        <div className="flex items-center justify-between mb-2">
          <h3 className="text-xs font-medium dark:text-white">
            {" "}
            {translate("wallet.title")}
          </h3>
          <div className="flex items-center gap-1 text-gray-600 dark:text-gray-300">
            <span className="text-xs">{translate("wallet.earnCoins")}</span>
            <InfoIcon />
          </div>
        </div>

        {/* Wallet Balance */}
        <button
          className="relative h-[60px] mb-6 w-full max-w-md flex items-center justify-between rounded-lg p-4 overflow-hidden"
          style={{
            backgroundImage: `url(/images/LeaderBoardBG.jpeg)`,
            backgroundPosition: "center bottom",
            backgroundSize: "cover",
          }}
        >
          <div className="flex items-center justify-center gap-2 mb-2">
            <div>
              <img
                src="/png/Coins.png"
                alt={translate("wallet.title")}
                className="w-[48px] h-[48px]"
              />
            </div>
            <div>
              <span className="text-2xl font-bold text-white font-lt">
                {formatCurrency(user?.dg_coin_wallet_balance)}
              </span>
              <p className="text-center text-white text-xs">
                {selectedCurrency?.symbol || "$"}
                {formatCurrency(
                  convertCurrency(
                    user?.dg_coin_wallet_balance,
                    "Coins",
                    selectedCurrency?.symbol || "$",
                    appData.currencies
                  )
                )}
              </p>
            </div>
          </div>
        </button>

        {/* Fund Button */}
        <button
          className="w-full py-3  text-white rounded-lg bg-gradient-to-b from-[#039EF2] to-[#027EC2] font-medium flex items-center justify-center gap-2"
          type="button"
          onClick={() => {
            setIsOpen(false);
            navigate("/products/dg_coins/DGCoin");
          }}
        >
          {/* <span>{translate("wallet.fundWallet")}</span> */}
          <span>Buy DG Coins</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M14 5l7 7m0 0l-7 7m7-7H3"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};
